import React from 'react';
import AnalyticsInterval from '../../../models/analytics/AnalyticsInterval';
import ContentAnalyticsCharts from './ContentAnalyticsCharts';
import ContentInteractionAnalyticsContainer from '../../../state/containers/ContentInteractionAnalyticsContainer';
import AnalyticsRequestFilter from '../../../models/analytics/AnalyticsRequestFilter';

interface ContentInteractionsChartsProps {
    stateContainer: ContentInteractionAnalyticsContainer
    interval: AnalyticsInterval
    innerInterval: AnalyticsInterval
    filter: AnalyticsRequestFilter
    applicationId: string
    contentId: string
}
class ContentInteractionsCharts extends React.Component<ContentInteractionsChartsProps> {
    componentDidMount() {
        this.loadChartData();
    }

    componentDidUpdate(previousProps: ContentInteractionsChartsProps) {
        if (previousProps.interval !== this.props.interval
            || JSON.stringify(previousProps.filter) != JSON.stringify(this.props.filter)) {

            this.loadChartData();
        }
    }

    async loadChartData() {
        this.setState({
            ...this.state,
            isLoadingHistograms: true
        })
        this.props.stateContainer.loadPrimaryBreakdown(
            {applicationId: this.props.applicationId, contentId: this.props.contentId},
            this.props.filter,
            this.props.stateContainer.state.currentBreakdown)

        this.props.stateContainer.loadSecondaryBreakdown(
            {applicationId: this.props.applicationId, contentId: this.props.contentId},
            this.props.filter,
            this.props.stateContainer.state.currentBreakdown)

        await this.props.stateContainer.loadPrimaryHistogram(
            {applicationId: this.props.applicationId, contentId: this.props.contentId},
            this.props.innerInterval,
            this.props.filter
        )
        await this.props.stateContainer.loadSecondaryHistogram(
            {applicationId: this.props.applicationId, contentId: this.props.contentId},
            this.props.innerInterval,
            this.props.filter
        );
        await this.props.stateContainer.getAverages(
            {applicationId: this.props.applicationId, contentId: this.props.contentId},
            this.props.filter)
    }


    render() {
        return (
            <ContentAnalyticsCharts
                applicationId={this.props.applicationId}
                contentId={this.props.contentId}
                filter={this.props.filter}
                innerInterval={this.props.innerInterval}
                interval={this.props.interval}
                dataType='Interactions'
                stateContainer={this.props.stateContainer}
                showSecondary={this.props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("session") > -1}
                showPrimary={this.props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("interactions") > -1}
                secondaryDataName="Sessions"
                primaryDataName="Interactions" />
        )
    }
}

export default ContentInteractionsCharts;